export default __webpack_public_path__ + "static/N0193-f7bf551fe3b65c1936f8138f320cc6c0.png";